import React, {useContext, useEffect, useState} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import {DispatchContext} from '../../../store';
import {usersActionServices, usersAPi} from '../../../services/UserServices';
import Typography from '@mui/material/Typography';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {SNACKBAR_OPEN} from '../../../reducers';
import DeleteDialog from '../../../common/DeteleDialog/DeleteDialog';
import InviteUsers from './InviteUsers';

export default function UserLists(props) {
  const {roleIds, setUserId, handleOpen, handleShowOpen, users, setUsers, meta, setMeta } = props;
  const dispatch = useContext(DispatchContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUser, setSelectedUser] = useState({});

  useEffect(() => {
    getUserList();
  }, [page, rowsPerPage]);

  const getUserList = () => {
    usersAPi('get', {role_id: roleIds, page: page, per_page: rowsPerPage}).then(res => {
      setUsers(res?.data);
      setMeta(res?.meta);
    })
  }

  const handleChangePage = (event, newPage) => {
    dispatch({type: 'IS_NOT_LOADING', payload: false});
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleClick = (event, userId, userData) => {
    setSelectedUser(userData);
    setAnchorEl(event.currentTarget);
    setSelectedUserId(userId);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const editUser = () => {
    setUserId(selectedUserId);
    handleOpen();
    handleClose();
  }

  const handleDeleteUser = () => {
    setUserId(selectedUserId);
    handleShowOpen();
    handleClose();
  }

  const handleToggleActive = () => {
    if (selectedUser?.is_active) {
      usersActionServices('put', selectedUserId, null, {is_active: false}).then(res => {
        handleClose();
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'User deactivated successfully'}
        });
        getUserList();
      })
    } else {
      usersActionServices('put', selectedUserId, null, {is_active: true}).then(res => {
        handleClose();
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'User activated successfully'}
        });
        getUserList();
      })
    }
  }

  return (
    <div>
      <TableContainer className={'box-shadow'} component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{color: '#B3B3B3', width: 20}}>Sl.No</TableCell>
              <TableCell><span style={{color: '#B3B3B3'}}>Name</span> / CID</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Employee ID</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Agency</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Contact No.</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Email ID</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Status</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Action</TableCell>
              <TableCell colSpan={2} align="right"/>
            </TableRow>
          </TableHead>
          <TableBody>
            {users?.length > 0 && users?.map((user, index) => (
              <TableRow key={index}>
                <TableCell align="left" sx={{color: '#3D3D3D', width: 20}}>{index + 1}</TableCell>
                <TableCell sx={{display: 'flex', flexDirection: 'column'}}>
                  <Typography className={'text-capitalize'}
                              sx={{fontSize: 14, color: '#3D3D3D'}}>{user?.first_name || '-'}</Typography>
                  <Typography className={'text-capitalize'}
                              sx={{fontSize: 14, color: '#616B88'}}>{user?.cid || '-'}</Typography>
                </TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}}>{user?.emp_id || '-'}</TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}}>{user?.profile?.agency || '-'}</TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}}>{user?.phone || '-'}</TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}}>{user?.email || '-'}</TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}}>
                  {user?.is_active ?
                    <Typography sx={{color: '#00BA1E', fontWeight: 15, fontSize: 15}}>
                      Active
                    </Typography> :
                    <Typography sx={{color: '#FF3838', fontWeight: 15, fontSize: 15}}>
                      Inactive
                    </Typography>
                  }
                </TableCell>
                <TableCell colSpan={2}>
                  <IconButton onClick={(event) => handleClick(event, user?.id, user)}>
                    <MoreHorizIcon/>
                  </IconButton>
                </TableCell>
                <Menu
                  key={user?.id}
                  id="long-menu"
                  MenuListProps={{
                    'aria-labelledby': 'long-button',
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  PaperProps={{
                    style: {
                      maxHeight: 48 * 4.5,
                      width: '15ch',
                      backgroundColor: '#616B88',
                    },
                  }}
                >
                  {(selectedUser?.is_active === true) ?
                    <MenuItem sx={{
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: '#8592B8',
                      },
                    }} onClick={handleToggleActive}>
                      Deactivate
                    </MenuItem> :
                    <MenuItem sx={{
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: '#8592b8',
                      },
                    }} onClick={handleToggleActive}>
                      Activate
                    </MenuItem>
                  }
                  <MenuItem sx={{
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#8592B8',
                    },
                  }} onClick={editUser}>
                    Edit
                  </MenuItem>
                </Menu>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}